export default __webpack_public_path__ + "static/media/(11).53cb8fb2.jpeg";